import { aboutInfo, siteInfo } from '@/mocks/webtoons';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const pageTitle = `关于我们 - ${siteInfo.name}`;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        foundingDate: siteInfo.foundingYear,
        email: aboutInfo.contact.email,
        address: {
          '@type': 'PostalAddress',
          streetAddress: aboutInfo.contact.address,
          addressCountry: 'CN',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: aboutInfo.contact.phone,
          contactType: 'customer service',
        },
      },
      {
        '@type': 'AboutPage',
        name: pageTitle,
        description: aboutInfo.brandIntro,
        url: `https://qmss2.cn/about`,
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="mb-4">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="mb-14">
          <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
            关于韩漫网
          </h1>
          <div className="max-w-3xl">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              {aboutInfo.brandIntro}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.mission}
            </p>
          </div>
        </section>

        <section className="mb-14">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
            核心优势
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {aboutInfo.values.map((value, index) => (
              <div
                key={index}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60"
              >
                <h3 className="font-heading text-lg text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-14">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
            平台数据
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
            {aboutInfo.reputation.map((item, index) => (
              <div
                key={index}
                className="p-5 md:p-6 rounded-xl bg-accent-100 text-center"
              >
                <p className="font-heading text-2xl md:text-3xl text-accent-900 mb-1">
                  {item.metric}
                </p>
                <p className="text-sm text-accent-700">{item.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
            联系我们
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                <p className="text-sm text-foreground-600">{aboutInfo.contact.email}</p>
              </div>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className="ri-wechat-line text-lg text-accent-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">微信</p>
                <p className="text-sm text-foreground-600">{aboutInfo.contact.wechat}</p>
              </div>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                <i className="ri-weibo-line text-lg text-secondary-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">微博</p>
                <p className="text-sm text-foreground-600">{aboutInfo.contact.weibo}</p>
              </div>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                <i className="ri-phone-line text-lg text-primary-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">客服电话</p>
                <p className="text-sm text-foreground-600">{aboutInfo.contact.phone}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}